import * as React from 'react';
import { GridSelectionModel } from '@mui/x-data-grid-pro';
import { WatchList } from 'services/clients/watchList';
import { Container } from 'types/Watchlist';
import { useSelectionContext } from 'common/contexts/SelectionContext';

export const useContainerSelection = (
  keyFunction: (container: Container) => string,
  watchList?: WatchList
) => {
  const { selection, setSelection } = useSelectionContext();

  const handleOnSelectionModelChange = (gridSelection: GridSelectionModel) => {
    if (gridSelection.length === 0 || !watchList?.results) {
      setSelection({ model: 'none' });
      return;
    }

    const selectedContainers = watchList.results.filter((c) => {
      const key = keyFunction(c);
      return gridSelection.includes(key);
    });
    setSelection({
      model: 'page',
      containers: selectedContainers,
      totalCount: watchList.count,
    });
  };

  // This effect makes sure our selection always has the latest data
  React.useEffect(() => {
    setSelection((s) => {
      if (s.model === 'none') {
        return s;
      }

      if (!watchList) {
        return { model: 'none' };
      }

      if (s.model === 'filter') {
        return {
          ...s,
          totalCount: watchList.count,
        };
      }

      const previouslySelected = s.containers.map((c) => c.containerNumber);

      return {
        ...s,
        containers: watchList.results.filter((c) => previouslySelected.includes(c.containerNumber)),
        totalCount: watchList.count,
      };
    });
    // Intentionally ONLY watch the watchlist
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchList]);

  let selectionModel: string[] = [];
  switch (selection.model) {
    case 'page':
      selectionModel = selection.containers.map((c) => {
        const key = keyFunction(c);
        return key;
      });
      break;
    case 'filter':
      selectionModel =
        watchList?.results.map((c) => {
          const key = keyFunction(c);
          return key;
        }) || [];
      break;
    default:
      break;
  }

  return { handleOnSelectionModelChange, selectionModel, selection };
};
